import React from 'react'
import { RouteProps } from 'react-router-dom'

import { useLoaderPageProps } from '../../../templates/Loader/useProps'
import LoaderTemplate from '../../../templates/Loader'

const LoaderPage: React.FC<RouteProps> = () => {
  const templateProps = useLoaderPageProps()

  return <LoaderTemplate {...templateProps} />
}

export default LoaderPage
